<template>
  <div class="x600">
    <vs-prompt
      :vs-title="'Mesaj Ekle #' + serviceId"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-close="cancel"
      @vs-cancel="cancel"
      :vs-active.sync="visible"
      vs-accept-text="Kaydet"
      @vs-accept="submit"
      :vs-is-valid="validateForm"
    >
      <vcl-table secondary="#ff9f43" v-if="loading"></vcl-table>
      <div class="vx-row ml-5 mr-5" v-if="!loading">
        <p class="mb-5">Önceki Mesajlar</p>
        <span id="lblNotes" class="w-full mb-10"></span>
        <vs-textarea
          class="w-full"
          v-model="currentNote"
          placeholder="Mesajınızı yazın"
          v-validate="'required'"
          name="txtMessage"
          :color="validateForm ? 'success' : 'danger'"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclTable } from "vue-content-loading";

export default {
  components: {
    VclTable,
  },
  props: {
    serviceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
      previousNotes: "",
      currentNote: "",
      loading: true,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    getData: async function () {
      if (!(this.serviceId > 0)) {
        this.$vs.notify({
          title: "Hata",
          text: "Servis bilgisi alınamadı!",
          color: "primary",
        });
        this.loading = false;
        return;
      }
      let a = await repository
        .postEntity("technic/getOrders", {
          id: this.serviceId,
        })
        .then((r) => r.list)
        .then((r) => r[0]);
      a = repository.convertToJSON(a, "serviceNote");
      if (
        typeof a.serviceNote != "object" ||
        !a.serviceNote.customer ||
        !a.serviceNote.technic
      ) {
        a.serviceNote = { customer: "", technic: [] };
      }
      this.beautifyServiceNotes(a.serviceNote);
      this.loading = false;
    },
    beautifyServiceNotes(currentItem) {
      this.previousNotes =
        "<div class='mb-5'><b>Müşteri: </b>" + currentItem.customer + "</div>";
      if (Array.isArray(currentItem.technic)) {
        let ctr = 1;
        for (var i = 0; i < currentItem.technic.length; i++) {
          if (currentItem.technic[i].trim().length > 0) {
            this.previousNotes +=
              "<div class='pb-2'>" +
              ctr +
              ". " +
              currentItem.technic[i] +
              "</div>";
            ctr++;
          }
        }
      } else {
        if (currentItem.technic.trim().length > 0)
          this.previousNotes += ": 1. " + currentItem.technic + "<br/>";
      }
      setTimeout(() => {
        document.getElementById("lblNotes").innerHTML = this.previousNotes;
      }, 100);
    },
    cancel() {
      this.visible = true;
      this.$emit("updateCompleted", 0);
    },
    submit() {
      this.visible = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          //mesajı Kaydet
          let postModel = {
            serviceId: this.serviceId,
            serviceNote: this.currentNote,
          };
          repository.postEntity("Technic/addMessage", postModel).then((r) => {
            if (r.isSuccessful) {
              this.$vs.notify({
                color: "success",
                title: `Başarılı! `,
                text: "Ekleme işlemi tamamlandı.",
              });
            } else if (r.hasExceptionError) {
              this.$vs.notify({
                color: "danger",
                title: `${r.exceptionMessage}`,
                text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
              });
            } else {
              this.$vs.notify({
                color: "danger",
                title: `${r.exceptionMessage}`,
                text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
              });
            }
          });
          this.$emit("updateCompleted", this.serviceId);
        }
      });
    },
  },
};
</script>
